import { useTranslation } from 'react-i18next';

const STEP_KEYS = ['PENDING', 'CONFIRMED', 'PACKING', 'SHIPPED', 'OUT_FOR_DELIVERY', 'DELIVERED'];

const stepIndex = (status) => {
  if (['REJECTED', 'CANCELLED'].includes(status)) return -1;
  const idx = STEP_KEYS.findIndex((s) => s === status);
  if (idx >= 0) return idx;
  if (status === 'DELIVERED') return STEP_KEYS.length - 1;
  return 0;
};

const OrderStatusStepper = ({ status }) => {
  const { t } = useTranslation();
  const current = stepIndex(status);
  const failed = ['REJECTED', 'CANCELLED'].includes(status);

  if (failed) {
    return (
      <p className="text-sm text-red-400">
        {t('status.orderFailed', { status: t(`status.order.${status}`, { defaultValue: status.toLowerCase() }) })}
      </p>
    );
  }

  return (
    <ol className="flex flex-wrap gap-2 text-xs sm:gap-4">
      {STEP_KEYS.map((key, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={key} className="flex items-center gap-1">
            <span
              className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] ${
                done ? 'bg-emerald-600 text-white' : active ? 'bg-glow-600 text-white' : 'bg-zinc-100 dark:bg-zinc-800 text-zinc-600 dark:text-zinc-500'
              }`}
            >
              {done ? '✓' : '○'}
            </span>
            <span className={active ? 'text-glow-300' : done ? 'text-zinc-700 dark:text-zinc-300' : 'text-zinc-600 dark:text-zinc-500'}>
              {t(`status.orderStep.${key}`)}
            </span>
          </li>
        );
      })}
    </ol>
  );
};

export default OrderStatusStepper;
